export const getEditorState = (state) => state.get('editorState');
export const getSavedEditorSelection = (state, { editorId }) => state.getIn(['savedSelection', editorId]);

export const getEditorId = (state) => state.get('editorId');
export const getOriginalEditorIdSelector = (state) => state.get('originalEditorId');
